import { useState, useEffect } from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import AccountAppsFilter from './AccountAppsFilter'

import { useAppSelector, useAppDispatch } from 'app/state'
import { App } from 'features/apps/types'
import { AppTypes } from 'features/apps/types'
import AddIcon from '@mui/icons-material/Add'
import { myAppsResource, setFilteredApps } from 'features/apps/state/appsSlice'
import AccountAppsTable from './AccountAppsTable/AccountAppsTable'
import { useResource } from 'app/state/resource'
import { Button, Typography } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'

function filterAppByType(apps: App[], type: AppTypes = AppTypes.Listed) {
  return apps.filter((a) => a.type === type)
}

function AccountAppsList() {
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const navigate = useNavigate()
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))
  const { data: apps } = useResource(myAppsResource)
  const filteredApps = useAppSelector((state) => state.apps.filteredApps)
  const myAppsListFilter = useAppSelector((state) => state.apps.myAppsListFilter)

  const [searchString, setSearchString] = useState<string | undefined>()

  useEffect(() => {
    let filtered = filterAppByType(apps || [])

    const { searchBy } = myAppsListFilter
    if (searchBy) {
      filtered = filtered.filter((app) => {
        const searchByLower = searchBy.toLowerCase()
        return app.title.toLowerCase().includes(searchByLower) || app.description.toLowerCase().includes(searchByLower)
      })
    }
    setSearchString(searchBy)
    dispatch(setFilteredApps(filtered))
  }, [apps, dispatch, myAppsListFilter])

  return (
    <>
      <Typography mb={3} variant="body2" color="textSecondary">
        <FormattedMessage id="account.cards.apps.description" />
      </Typography>
      <Box display="flex" justifyContent="space-between" mt={0.5}>
        <Box flex={1} mr={2}>
          {(filteredApps.length && !searchString) || searchString ? <AccountAppsFilter /> : ''}
        </Box>
        <Button onClick={() => navigate('create')} variant="contained" color="primary" startIcon={<AddIcon />}>
          <FormattedMessage id={isXs ? 'account.cards.apps.registerNewShort' : 'account.cards.apps.registerNew'} />
        </Button>
      </Box>
      <Box mt={3}>
        <AccountAppsTable />
      </Box>
    </>
  )
}

export default AccountAppsList
